import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { setDefaultSetting } from "../store";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { refreshPays } from "./helper";

export function useSyncDefaultSettingCurrency(data: any, defaultSetting: any) {
    useEffect(() => {
        if (data.data === undefined) return;
        setDefaultSetting({
            ...defaultSetting,
            currency: { data: [...data.data] },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
}

export function useInitCurrencyForm(
    devises: any,
    setTitle: (val: string) => void,
    setDesignation: (val: string) => void,
    setSymbol: (val: string) => void,
    setDecimalNumber: (val: string) => void,
    setDecimalDesignation: (val: string) => void,
    setCountryData: (val: any) => void,
    setChange: (val: string) => void,
    setTagsData: (val: any) => void,
    getCurrencies: () => void
) {
    const { t } = useTranslation();

    useEffect(() => {
        clearData();
        setTitle(t("Modify a currency"));
        setDesignation(devises[t("Display name")]);
        setSymbol(devises[t("Symbol")]);
        setDecimalNumber(devises[t("Nbr decimal")]);
        setDecimalDesignation(devises[t("Decimal designation")]);
        setCountryData(devises[t("Country")]?.split(","));
        setChange(devises[t("Currency")]);
        setTagsData(devises[t("Tag")]?.split(","));
        getCurrencies();

        // eslint-disable-next-line
    }, [devises.id, t]);
}

export function useFetchPaysCurrency(
    i18nextLng: string,
    oneShop: boolean,
    shopPays: any,
    setCountryList: (val: any) => void,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    useEffect(() => {
        refreshPays(i18nextLng, oneShop, shopPays, setCountryList, fetchGlobal);
        // eslint-disable-next-line
    }, []);
}

export function useResetCurrencyValidation(
    devises: any,
    countryData: any,
    decimalNumber: string,
    decimalDesignation: string,
    setInputDesignation: (val: boolean) => void,
    setInputChange: (val: boolean) => void,
    setSelectCountry: (val: boolean) => void,
    setInputDecimalNumber: (val: boolean) => void,
    setInputdesignationDecimal: (val: boolean) => void
) {
    const { t } = useTranslation();

    useEffect(() => {
        if (Object.values(devises).length !== 0) {
            if (devises[t("Display name")] !== "") {
                setInputDesignation(false);
            }
            if (devises[t("Currency")] !== "") {
                setInputChange(false);
            }
            if (countryData?.length !== 0) {
                setSelectCountry(false);
            }
            if (decimalNumber !== "") {
                setInputDecimalNumber(false);
            }
            if (decimalDesignation !== "") {
                setInputdesignationDecimal(false);
            }
        }
        // eslint-disable-next-line
    }, [devises]);
}
